export const AzureLoginConfig = {
  appId: process.env.REACT_APP_ID,
  // redirectUri: "http://localhost:3000",
  redirectUri: process.env.REACT_APP_REDIRECT_URL,
  scopes: ["user.read"],
  authority: process.env.REACT_APP_authorityURL,
};
